// eslint-disable-next-line import/prefer-default-export
export const ShiftDisplayType = Object.freeze({
    ShiftLabel: 'ShiftLabel',
    ShiftTime: 'ShiftTime',
});

